// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KPEP","rootNoMargin":"styles_rootNoMargin__290vX"};